import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'usehooks-ts'

import { useModalStore } from '@features/modal'

import { useIsAdult } from '@shared/hooks'
import Button from '@shared/ui/button'

import styles from './styles.module.scss'

interface IsAdultProps {
  onConfirm?: () => void;
  onCancel?: () => void;
}

export default function IsAdult ({ onConfirm, onCancel }: IsAdultProps) {
  const { t } = useTranslation('isAdult')
  const { setIsAdult } = useIsAdult()
  const isTablet = useMediaQuery('(max-width: 768px)')
  const { closeModal } = useModalStore()

  const handleConfirm = () => {
    setIsAdult(true)
    closeModal('isAdult', true)
    onConfirm?.()
  }

  const handleCancel = () => {
    closeModal('isAdult', true)
    onCancel?.()
  }

  return (
    <div className={styles.root}>
      <h3 className={styles.root__title}>{t('title')}</h3>
      <div className={styles.root__group}>
        <Button
          className={styles.root__button}
          size={isTablet ? 'medium' : 'large'}
          onClick={handleConfirm}
        >
          {t('button.confirm')}
        </Button>
        <Button
          className={styles.root__button}
          size={isTablet ? 'medium' : 'large'}
          theme="secondary"
          onClick={handleCancel}
        >
          {t('button.cancel')}
        </Button>
      </div>
    </div>
  )
}
